import * as React from 'react'

function AccountConnectSVG(props) {
  return (
    <svg width={474} height={309} viewBox="0 0 474 309" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g opacity={0.8}>
        <path
          d="M323.449 18c4.618-8 16.165-8 20.784 0l99.456 172.263c4.619 8-1.154 18-10.392 18H234.384c-9.237 0-15.011-10-10.392-18L323.449 18z"
          fill="#F7A723"
        />
        <path
          d="M323.449 18c4.618-8 16.165-8 20.784 0l99.456 172.263c4.619 8-1.154 18-10.392 18H234.384c-9.237 0-15.011-10-10.392-18L323.449 18z"
          fill="#fff"
          fillOpacity={0.9}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M360.606 100.173c3.462.204 6.466 1.579 9.011 4.124 2.546 2.546 3.92 5.549 4.124 9.011v35.739l-22.91 22.91v19.55h-32.379v-19.55l-22.91-22.91v-35.739c.204-3.462 1.579-6.465 4.124-9.011 2.546-2.545 5.549-3.92 9.011-4.124V74.209h12.83v25.964h26.27V74.209h12.829v25.964zm-22.519 42.405h-6.415l-1.01-23.38h8.435l-1.01 23.38zm-6.409 4.429c-.838.744-1.257 1.696-1.257 2.855s.419 2.111 1.257 2.855c.838.744 1.883 1.116 3.137 1.116 1.253 0 2.298-.372 3.136-1.116.838-.744 1.257-1.696 1.257-2.855s-.419-2.111-1.257-2.855c-.838-.744-1.883-1.116-3.136-1.116-1.254 0-2.299.372-3.137 1.116z"
        fill="#BBC2CC"
        fillOpacity={0.6}
      />
      <g filter="url(#filter0_d_876_24062)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.317 84.75c0-8.698 7.051-15.75 15.75-15.75h173.421c8.699 0 15.75 7.052 15.75 15.75v61.264c0 8.698-7.051 15.75-15.75 15.75H32.067c-8.699 0-15.75-7.052-15.75-15.75V84.75z"
          fill="#fff"
        />
      </g>
      <path
        opacity={0.3}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.06 95.063a3.976 3.976 0 013.975-3.976h132.211a3.976 3.976 0 110 7.951H38.035a3.976 3.976 0 01-3.976-3.975z"
        fill="#1B3554"
      />
      <rect opacity={0.3} x={34.0591} y={106.989} width={100.243} height={7.95116} rx={2.65039} fill="#1B3554" />
      <path
        opacity={0.15}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.06 135.7a3.975 3.975 0 013.975-3.975h24.871a3.975 3.975 0 110 7.951H38.035a3.976 3.976 0 01-3.976-3.976z"
        fill="#1B3554"
      />
      <ellipse opacity={0.3} cx={184.867} cy={125.542} rx={18.6292} ry={18.5527} fill="#1B3554" />
      <g>
        <g filter="url(#filter1_dd_876_24062)">
          <circle cx={257.238} cy={115.383} r={24} fill="#fff" />
        </g>
        <g clipPath="url(#clip0_876_24062)">
          <path
            d="M274.551 119.067l-1.508 1.143-1.503-1.047c0-.11 0-.227-.007-.344 0-.11 0-.227-.007-.343-.096-2.709-.784-5.61-2.159-7.735-1.058-1.629-2.413-2.406-3.925-2.406-1.588 0-2.881.949-4.311 3.011-.041.062-.089.124-.131.193-.027.034-.048.068-.075.11-.069.103-.138.206-.206.316-.619.962-1.265 2.083-1.967 3.321-.062.116-.13.233-.192.35a.622.622 0 00-.055.09l-.145.254-.852 1.506c-2.001 3.54-2.509 4.351-3.506 5.678-1.753 2.331-3.252 3.218-5.225 3.218-2.338 0-3.823-1.011-4.737-2.537-.75-1.238-1.114-2.867-1.114-4.723l3.417.117c0 1.21.261 2.131.612 2.695.454.728 1.12 1.01 1.815 1.01.887 0 1.712-.185 3.279-2.358 1.258-1.739 2.743-4.173 3.74-5.706l.942-1.437.199-.316.207-.31.343-.529a49.725 49.725 0 011.692-2.454 6.11 6.11 0 01.213-.289c.069-.096.144-.193.213-.282.619-.791 1.272-1.526 1.973-2.131 1.272-1.107 2.64-1.719 4.022-1.719 2.317 0 4.524 1.341 6.215 3.857 1.726 2.571 2.626 5.775 2.729 9.109.007.11.007.227.007.344.007.117.007.227.007.344z"
            fill="#0081FB"
          />
          <path
            d="M245.619 109.508c1.566-2.41 3.826-4.095 6.418-4.095 1.501 0 2.993.444 4.552 1.714 1.704 1.389 3.521 3.675 5.788 7.444l.813 1.353c1.962 3.262 3.078 4.941 3.731 5.733.84 1.016 1.365 1.287 2.13 1.287 1.938 0 2.486-1.746 2.486-3.782l3.014-.094c0 2.128-.421 3.691-1.136 4.926-.69 1.194-2.036 2.388-4.301 2.388-1.408 0-2.655-.305-4.034-1.604-1.06-.997-2.299-2.768-3.253-4.36l-2.837-4.729c-1.423-2.373-2.728-4.143-3.484-4.944-.813-.862-1.816-1.894-3.483-1.894-1.35 0-2.537.937-3.496 2.382l-2.908-1.725z"
            fill="url(#paint0_linear_876_24062)"
          />
          <path
            d="M252.035 108.851c-1.346 0-2.532.936-3.489 2.382-1.353 2.043-2.182 5.086-2.182 8.008 0 1.206-.003 2.112.343 2.672l-2.64 1.934c-.746-1.242-1.141-2.828-1.141-4.684 0-3.376.932-6.937 2.694-9.655 1.563-2.41 3.842-4.095 6.429-4.095l-.014 3.438z"
            fill="url(#paint1_linear_876_24062)"
          />
          <path
            opacity={0.05}
            d="M257.136 112.817l-.206.309-.199.317a46.72 46.72 0 011.629 2.537l.144-.255a.715.715 0 01.055-.089c.062-.117.131-.234.193-.351a44.752 44.752 0 00-1.616-2.468zm2.248-3.272a8.867 8.867 0 00-.213.288 31.419 31.419 0 011.547 2.132c.069-.11.138-.214.206-.317.028-.041.049-.075.076-.11.041-.068.089-.13.131-.192a30.772 30.772 0 00-1.533-2.083c-.069.089-.145.185-.214.282z"
            fill="#000"
          />
          <path
            opacity={0.07}
            d="M257.136 112.819l-.206.31c.488.701 1.038 1.54 1.629 2.509.062-.117.131-.234.193-.35a45.192 45.192 0 00-1.616-2.469zm2.035-2.983a31.135 31.135 0 011.547 2.131c.069-.11.138-.213.206-.316a32.315 32.315 0 00-1.54-2.104 7.923 7.923 0 00-.213.289z"
            fill="#000"
          />
        </g>
      </g>
      <g>
        <g filter="url(#filter2_dd_876_24062)">
          <circle cx={148.129} cy={228.352} r={24} fill="#25D366" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M149.076 214.685c3.732.082 6.829 1.353 9.29 3.814 2.461 2.461 3.732 5.558 3.814 9.29-.082 3.733-1.353 6.829-3.814 9.29-2.461 2.461-5.558 3.733-9.29 3.815-2.625-.041-4.963-.718-7.014-2.031l-6.091 2.031 2.03-6.091c-1.312-2.051-1.989-4.389-2.03-7.014.082-3.732 1.354-6.829 3.815-9.29 2.461-2.461 5.557-3.732 9.29-3.814zm6.214 15.688c.328.123.522.236.584.338.062.103.082.298.062.585-.021.287-.113.625-.277 1.015-.164.39-.492.728-.985 1.015-.492.287-.923.431-1.292.431-.205.082-.512.113-.923.092-.41-.02-1.394-.359-2.953-1.015-1.64-.82-2.922-1.825-3.845-3.015-.923-1.189-1.435-1.876-1.538-2.061-.102-.184-.328-.605-.677-1.261-.348-.656-.512-1.394-.492-2.215.021-.82.174-1.435.462-1.845.287-.411.533-.698.738-.862.369-.328.677-.451.923-.369h.615c.082 0 .184.021.308.062.123.041.246.225.369.553l.923 2.461c.123.164.123.349 0 .554l-.308.554-.554.553a.824.824 0 00-.184.277c-.041.103-.021.236.061.4.082.164.277.472.585.923.307.451.687.923 1.138 1.415.615.533 1.148.923 1.599 1.169l.985.492c.287.205.512.185.677-.061l1.045-1.231c.123-.123.247-.184.37-.184s.266.02.43.061l2.154 1.169zm-13.659-10.028c1.969-1.969 4.451-2.994 7.445-3.076 2.994.082 5.475 1.107 7.444 3.076 1.969 1.968 2.994 4.45 3.076 7.444-.082 2.994-1.107 5.476-3.076 7.444-1.969 1.969-4.45 2.995-7.444 3.077-2.297-.041-4.307-.677-6.03-1.908l-3.814 1.231 1.23-3.815c-1.23-1.722-1.866-3.732-1.907-6.029.082-2.994 1.108-5.476 3.076-7.444z"
          fill="#fff"
        />
        <g>
          <g filter="url(#filter3_d_876_24062)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M184.129 197.719c0-8.699 7.052-15.75 15.75-15.75h173.422c8.698 0 15.75 7.051 15.75 15.75v61.263c0 8.699-7.052 15.75-15.75 15.75H199.879c-8.698 0-15.75-7.051-15.75-15.75v-61.263z"
              fill="#fff"
            />
          </g>
          <path
            opacity={0.3}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M201.872 208.031a3.975 3.975 0 013.975-3.975h132.212a3.975 3.975 0 010 7.951H205.847a3.976 3.976 0 01-3.975-3.976z"
            fill="#1B3554"
          />
          <rect opacity={0.3} x={201.872} y={219.958} width={100.243} height={7.95116} rx={2.65039} fill="#1B3554" />
          <path
            opacity={0.15}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M201.872 248.669a3.976 3.976 0 013.975-3.976h24.872a3.975 3.975 0 013.975 3.976 3.975 3.975 0 01-3.975 3.976h-24.872a3.976 3.976 0 01-3.975-3.976z"
            fill="#1B3554"
          />
          <ellipse opacity={0.3} cx={352.68} cy={238.511} rx={18.6292} ry={18.5527} fill="#1B3554" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_876_24062"
          x={1.31689}
          y={69}
          width={234.921}
          height={125.763}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_876_24062" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_876_24062" result="shape" />
        </filter>
        <filter
          id="filter1_dd_876_24062"
          x={218.238}
          y={83.8828}
          width={78}
          height={88.5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_876_24062" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_876_24062" result="effect2_dropShadow_876_24062" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_876_24062" result="shape" />
        </filter>
        <filter
          id="filter2_dd_876_24062"
          x={109.129}
          y={196.852}
          width={78}
          height={88.5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_876_24062" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={5} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_876_24062" result="effect2_dropShadow_876_24062" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_876_24062" result="shape" />
        </filter>
        <filter
          id="filter3_d_876_24062"
          x={169.129}
          y={181.969}
          width={234.921}
          height={125.763}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={12} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_876_24062" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_876_24062" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_876_24062"
          x1={271.322}
          y1={115.897}
          x2={251.542}
          y2={115.897}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset={0.995} stopColor="#0064E1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_876_24062"
          x1={247.488}
          y1={121.48}
          x2={247.488}
          y2={107.828}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset={0.995} stopColor="#0064E1" />
        </linearGradient>
        <clipPath id="clip0_876_24062">
          <path fill="#fff" transform="matrix(1.5 0 0 1.5 242.238 98.883)" d="M0 0H22V22H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AccountConnectSVG
